<!--
 * @message: 文件上传组件
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-21 14:40:26
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_FileDragUpdate.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-06-20 10:04:14
-->
<template>
  <div>
    <v-sheet class="text-center align-center" v-if="uploading">
      <v-progress-circular
        :size="98"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-sheet>
    <v-sheet class="gery--text" v-if="!uploading">
      {{ title }}
    </v-sheet>
    <div
      :style="{
        border: disabled ? 'none' : '2px dashed var(--main-border-color)',
      }"
      v-if="!uploading"
      class="rounded pa-3 max-width"
      @dragover="fileDragover"
      @drop="fileDrop"
    >
      <v-form enctype="multipart/form-data" method="post">
        <v-file-input
          id="fileInput"
          hide-input
          enctype="multipart/form-data"
          v-show="false"
          @change="chooseUploadFile"
        ></v-file-input>
      </v-form>

      <v-sheet v-if="fileList.length" class="text-left align-center">
        <v-list-item
          two-line
          v-for="(item, index) in fileList"
          :key="item.id"
          class="rounded mt-2 pt-2 pb-2"
          style="border: 1px solid var(--main-border-color)"
        >
          <v-list-item-avatar
            class="pa-0 pt-2 pb-2 mt-0 mb-0 mr-1 text--secondary"
            size="50"
            tile
            style="border: none"
            @click="
              curImageIndex = index;
              showImageBox = true;
            "
          >
            <!-- <span class="material-icons-round md-32"> attach_file </span> -->
            <svg-icon
              size="24"
              fill="#0f46c1"
              :iconClass="
                getType(item.filename) == 'jpg'
                  ? 'filetype-jpg'
                  : getType(item.filename) == 'csv'
                  ? 'filetype-csv'
                  : getType(item.filename) == 'doc'
                  ? 'filetype-doc'
                  : getType(item.filename) == 'gif'
                  ? 'filetype-gif'
                  : getType(item.filename) == 'png'
                  ? 'filetype-png'
                  : getType(item.filename) == 'xls'
                  ? 'filetype-xls'
                  : getType(item.filename) == 'docx'
                  ? 'filetype-doc'
                  : getType(item.filename) == 'xlsx'
                  ? 'filetype-xls'
                  : getType(item.filename) == 'pdf'
                  ? 'filetype-pdf'
                  : getType(item.filename) == 'ppt'
                  ? 'filetype-ppt'
                  : getType(item.filename) == 'jpeg'
                  ? 'filetype-jpg'
                  : 'filetype-file'
              "
            />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ item.filename }}</v-list-item-title>
            <v-list-item-subtitle>
              <v-chip x-small>{{ $byteconvert(item.size) }}</v-chip>
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action v-if="!disabled">
            <v-btn small icon @click="deleteItem(item.id)">
              <span class="material-icons-round">delete</span>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-sheet>

      <v-sheet
        v-if="single ? fileList.length == 0 : true"
        class="text-center align-center"
      >
        <div v-if="fileList.length == 0 && !disabled" class="text-center">
          <i class="material-icons-round md-72 text--secondary lighten-2"
            >backup</i
          >
        </div>
        <div v-if="fileList.length == 0 && !disabled">
          <v-btn
            width="50%"
            color="primary lighten-2  pl-12 pr-12 primary--text"
            depressed
            rounded
            class="text-capitalize"
            @click="toChoose"
            >{{ $t("label_essweb_update_components_browseBtnLabel") }}</v-btn
          >
        </div>
        <!-- bug 1469 juila -->
        <div class="pt-2 text--secondary" v-if="!disabled && 0">
          <span>{{
            $t("message_essweb_rosterRecord_dialog_canBeExportInLabel")
          }}</span>
        </div>
        <div class="pt-2 text--secondary" v-if="!disabled">
          <span v-if="0"
            >{{
              $t("message_essweb_rosterRecord_dialog_templateExportInLabel")
            }}
          </span>
          <!-- <span class="primary--text text-decoration-underline">{{
            $t("label_essweb_rosterRecord_dialog_templateForDownloadLabel")
          }}</span> -->
          <v-btn
            text
            small
            rounded
            @click="toUrl"
            depressed
            color="primary"
            class="
              primary--text
              text-decoration-underline text-capitalize
              ma-0
              pa-0
              pl-1
              pr-1
              mt-n1
              align-center
            "
            >{{
              $t("label_essweb_rosterRecord_dialog_templateForDownloadLabel")
            }}</v-btn
          >
        </div>
      </v-sheet>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "FileDragUpdate",
  props: {
    single: { default: false, type: Boolean },
    type: { default: "", type: String },
    title: { default: "", type: String },
    tempplateUrl: { default: "", type: String },
    disabled: { default: false, type: Boolean },
    closePop: { default: false, type: Boolean },
    curUuid: { default: null, type: [String, Number] },
    reload: { default: 123, type: Number },
    defaultImageList: {
      default: function () {
        return [];
      },
      type: [Array, String],
    },
    url: { default: "", type: String },
  },
  computed: {
    imageList() {
      let arr = [];
      this.fileList.forEach((item) => {
        if (item.updated) {
          arr.push({ code: item.code, data: item.data });
        }
      });
      return arr;
    },
  },
  data() {
    return {
      file: null,
      fileList: [],
      uploading: false,
      curImageIndex: 0,
      showImageBox: false,
    };
  },
  mounted() {},
  watch: {
    reload(val) {
      const that = this;
      this.fileList.forEach((item) => {
        if (!item.data) {
          item.updated = false;
          that.toUpdate(item.file, item.id);
        }
      });
    },
    closePop() {
      this.showImageBox = false;
    },
    defaultImageList(val) {
      const that = this;
      this.fileList = [];
      if (val)
        if (typeof val === "object") {
          val.forEach((item, index) => {
            that.fileList.push({
              id: dayjs().valueOf(),
              filename: item
                .toString()
                .substring(item.lastIndexOf("/") + 1, item.length),
              size: 0,
              file: null,
              data: item,
              code: "",
              updated: true,
            });
          });
        } else {
          this.fileList.push({
            id: dayjs().valueOf(),
            filename: val
              .toString()
              .substring(val.lastIndexOf("/") + 1, val.length),
            size: 0,
            file: null,
            code: "",
            data: val,
            updated: true,
          });
        }
    },
    imageList(val) {
      if (val.length) {
        if (this.single) {
          val = val[0];
        }
      } else {
        val = null;
      }

      this.$emit("change", val);
    },
    fileList(val) {
      const that = this;
      val.forEach((item) => {
        if (!item.updated) {
          that.toUpdate(item.file, item.id);
        }
      });
    },
  },
  methods: {
    toUrl: function () {
      if (this.tempplateUrl) location.href = this.tempplateUrl;
    },
    chooseUploadFile: function (file) {
      if (!file) return;
      if (!/\.(xls|xlsx)$/.test(file.name)) {
        this.$showMessage({
          type: "error",
          color: "error",
          text: this.$t(
            "message_essweb_update_components_onlyUpdateTableLabel"
          ),
        });
        return false;
      }
      if (file.size > 5 * 1000 * 1000) {
        this.$showMessage({
          type: "error",
          color: "error",
          text:
            this.$t("message_essweb_update_components_sizeLessThanLabel") +
            "5MB.",
        });
        return false;
      }

      this.fileList.push({
        id: dayjs().valueOf(),
        filename: file.name,
        size: file.size,
        file: file,
        data: "",
        code: "",
        updated: false,
      });
      $("#fileInput").val(null);
    },
    fileDragover: function (e) {
      e.preventDefault();
    },
    fileDrop: function (e) {
      e.preventDefault();
      const file = e.dataTransfer.files[0];
      if (!/\.(xls|xlsx)$/.test(file.name)) {
        this.$showMessage({
          type: "error",
          color: "error",
          text: this.$t(
            "message_essweb_update_components_onlyUpdateTableLabel"
          ),
        });
        return false;
      }
      if (file.size > 5 * 1000 * 1000) {
        this.$showMessage({
          type: "error",
          color: "error",
          text:
            this.$t("message_essweb_update_components_sizeLessThanLabel") +
            "5MB.",
        });
        return false;
      }
      this.fileList.push({
        id: dayjs().valueOf(),
        filename: file.name,
        size: file.size,
        file: file,
        data: "",
        code: "",
        updated: false,
      });
    },
    //获取文件后缀
    getType(filename) {
      if (!filename) return "";
      var index1 = filename.lastIndexOf(".");
      var index2 = filename.length;
      var type = filename.substring(index1 + 1, index2);
      return type;
    },
    deleteItem: function (id) {
      this.fileList = this.fileList.filter((ele) => ele.id !== id);
    },
    toChoose: function () {
      $("#fileInput").click();
    },
    toUpdate: function (f, id) {
      const that = this;
      this.uploading = true;
      let data = {
        file_name: f.name,
        files: f,
      };
      if (this.curUuid) data["uuid"] = this.curUuid;
      this.$Request({
        method: "POST",
        table: "ess_att_roster",
        url: this.url,
        data: data,
        type: this.type == "client" ? "client_import" : "import",
        global: false,
      })
        .then((res) => {
          that.fileList.forEach((item) => {
            if (item.id == id) {
              item.updated = true;
              item["code"] = res.code;
              item.data = res.data;
            }
          });
          that.$Sleep(2000).then(() => {
            that.uploading = false;
          });
        })
        .catch((res) => {
          that.fileList.forEach((item) => {
            if (item.id == id) {
              item.updated = true;
              item["code"] = 600;
              item.data = null;
            }
          });
          that.$Sleep(500).then(() => {
            that.uploading = false;
          });
        });
    },
  },
};
</script>
